import EmployeeManagement from './employee_management'

export default {
  "employee_management": EmployeeManagement
}



// WEBPACK FOOTER //
// ./src/pages/employee_management/index.js